interface TableOptions {
    tableHeight: number;
    headerHeight: number;
    currentRowHeight: number;
    footerScrollBarHeight: number;
}

export const getEmptyRowDataIndexByCurrentScrollPosition = <T>(
    currentScrollPosition: number,
    data: (T | null)[],
    opts: TableOptions
): number | undefined => {
    const {
        tableHeight,
        headerHeight,
        currentRowHeight,
        footerScrollBarHeight
    } = opts;

    const lastRowIndex =
        Math.ceil(
            (currentScrollPosition +
                tableHeight -
                headerHeight -
                footerScrollBarHeight) /
                currentRowHeight
        ) - 1;

    // первый видимый элемент таблички
    const firstRowIndex =
        currentScrollPosition === 0
            ? currentScrollPosition
            : Math.floor(currentScrollPosition / currentRowHeight);

    if (!data[firstRowIndex]) {
        return firstRowIndex;
    }

    if (!data[lastRowIndex]) {
        return lastRowIndex;
    }

    return undefined;
};
